import React from 'react'

import useCategory from 'components/GamesNavBar/hooks/useCategory'
import { Icon } from 'components/IconLink/Icon'
import { All_GAME_CATEGORY_SLUG } from 'containers/App/constants'

import { FilterElement } from './styles'

export function All() {
  const { category, changeCategory } = useCategory()

  const active = category === All_GAME_CATEGORY_SLUG
  const onClick = () => {
    changeCategory(All_GAME_CATEGORY_SLUG)
  }

  return (
    <FilterElement
      active={active}
      onClick={onClick}
    >
      <Icon icon={'all'} />
    </FilterElement>
  )
}
